import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import strings from 'utils/strings'
import { LoadingMeter, Row, Col, Paragraph } from 'components/patterns'
import { PartGraphicCustom } from 'components/SwitchAndGauge/Dash/Part/PartGraphicCustom'
import {
  Title,
  StyledAntdCard,
  StyledRadio,
} from './CustomSwitchDetailCard.style'

const CustomSwitchDetailCard = ({
  onSwitchSelection,
  partNumber,
  className,
  description,
  selectedPart,
  isCustomIndicator,
  panelNumber,
}) => {
  const handleSelection = () => {
    onSwitchSelection(partNumber, description)
  }

  const radioSelected = partNumber === selectedPart
  return (
    <StyledAntdCard className={className} onClick={handleSelection}>
      <Row>
        <Col span={3}>
          <StyledRadio checked={radioSelected} vertical={false} />
        </Col>
        <Col span={7}>
          {' '}
          {
            // it is ok to put the switch size here, these are always switches
          }
          <div style={{ width: 46, height: 98, position: 'relative' }}>
            <PartGraphicCustom
              capPartNumber={partNumber}
              dimensions={{ width: 48, height: 96 }}
              isCustomIndicator={isCustomIndicator}
              panelNumber={panelNumber}
              showPill={false}
            />
          </div>
        </Col>
        <Col span={14}>
          <Title>{partNumber}</Title>
          <Row>
            <Col span={24}>
              <Paragraph size="small" weight="bold">
                {strings.description}:
              </Paragraph>
              <Paragraph>{description}</Paragraph>
            </Col>
          </Row>
        </Col>
      </Row>
    </StyledAntdCard>
  )
}

CustomSwitchDetailCard.propTypes = {
  partNumber: PropTypes.string,
  description: PropTypes.string,
  className: PropTypes.string,
  selectedPart: PropTypes.string,
  onSwitchSelection: PropTypes.func,
  isCustomIndicator: PropTypes.bool,
  panelNumber: PropTypes.string,
}

export default CustomSwitchDetailCard

export const StyledLoadingMeter = styled(LoadingMeter)`
  position: absolute !important;
  bottom: 2px;
  left: 2px;
  z-index: 30;
`
